// Vendors.jsx
import Layout from '../components/Layout';

const Vendors = () => {
  return (
    <Layout>
      <h1 className="text-2xl font-bold text-gray-800">Vendors</h1>
      <p className="text-gray-500 mt-2">Vendors content will go here</p>
    </Layout>
  );
};

export default Vendors;